import React, { useState } from "react";
import Hovericon from "@/assets/videoparsing/selectaciveicon.png";
import "./index.less";
interface TonItemProps {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}
interface TonProps {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  Item?: React.FC<TonItemProps>; // 由于ts校验不支持静态绑定在Ton 直接采用 jsx写法默认写法 抛弃 TonProps强检测
}
const OtionItem = ({ children = null, className = "", style = {} }) => {
  return (
    <div className={className} style={style}>
      {children}
    </div>
  );
};

const Ton = ({
  children = null,
  className = "",
  style = {},
  contel = null,
  showHover= true
}) => {
  const [activehover, sethvoerstate] = useState(false);

  return (
    <div
      onMouseMove={() => {
        if (showHover) sethvoerstate(true);
      }}
      onMouseLeave={() => {
        sethvoerstate(false);
      }}>
      {!activehover ? (
        <div
          className={className ? className : "lgparsing-contel-bodydiv"}
          style={style}>
          {contel ? (
            contel
          ) : (
            <>
              <img src={Hovericon} alt="" />
              <p>选择素材</p>
              <p>嗨~ 快来上传素材 </p>
              <p> 玩转视频剪辑啦</p>
            </>
          )}
        </div>
      ) : (
        <div
          className={className ? className : "lgparsing-contel-bodyactive"}
          style={style}>
          {React.Children.map(children, (child) => {
            return child;
          })}
        </div>
      )}
    </div>
  );
};
Ton.Item = OtionItem;

export default Ton;
